import { FC, useEffect } from "react";
import styles from "./TagList.module.css";
import clsx from "clsx";
import { Button, Select, Switch } from "antd";

import CircleOrange from "assets/images/circle-orange-decorator.png";

import { useAppDispatch, useAppSelector, useQueryParams } from "hooks";
import {
  appendThemeTags,
  getLeftFiler,
  setEligibility,
  setHost,
  setThemeTags,
} from "store/ducks/filterHackathon/slice";
import { useMasterOrganization, useMasterTheme } from "api/master";
import { useHistory } from "react-router";

import { Tag } from "components/Tag";

const tagRender = (props: any) => {
  const { label, onClose } = props;
  const onPreventMouseDown = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
  };
  return (
    <Tag
      onMouseDown={onPreventMouseDown}
      type="primary"
      closable
      onClose={onClose}
      size="large"
      className={styles.tag}
    >
      {label}
    </Tag>
  );
};

const TagList: FC = () => {
  const history = useHistory();
  const dispatch = useAppDispatch();
  const {
    themeTags,
    eligibility,
    host: hostState,
  } = useAppSelector(getLeftFiler);
  const { data: tagOptions } = useMasterTheme();
  const { data: organizationOption } = useMasterOrganization();

  const query = useQueryParams();

  useEffect(() => {
    // Retrive filter query from deferent domain
    const host = query.get("host");
    const tag = query.get("tag");
    if (tag) dispatch(appendThemeTags(tag as string));
    if (host) dispatch(setHost(host as string));
    history.replace({ search: "" });
  }, []);

  const handleTagChange = (selected: string[]) => {
    dispatch(setThemeTags(selected));
  };
  const handleHostChange = (value: string) => {
    dispatch(setHost(value));
  };

  const handleEligibilityChange = () => {
    dispatch(setEligibility(!eligibility));
  };
  return (
    <div className={styles.root}>
      {/* Header */}
      <div className="f-between">
        <div className={styles.title}>Tags</div>
        <Button
          shape="round"
          size="small"
          className={styles.btnRemoveAll}
          type="text"
          onClick={() => handleTagChange([])}
        >
          Remove All Tags
        </Button>
      </div>

      <Select
        mode="multiple"
        value={themeTags}
        bordered={false}
        onChange={handleTagChange}
        tagRender={tagRender}
        className={styles.hostSelect}
        options={tagOptions?.map((tag) => ({ value: tag.name }))}
        placeholder="Search by keywords to add tag here"
      />

      <div className="f-between">
        <div className={styles.title}>Host</div>
      </div>

      <Select
        bordered={false}
        showSearch
        placeholder="Select host"
        className={styles.hostSelect}
        value={hostState}
        size="large"
        allowClear
        onChange={handleHostChange}
      >
        {organizationOption?.map((x) => (
          <Select.Option key={x._id} value={x.name}>
            {x.name}
          </Select.Option>
        ))}
      </Select>
      <div className={styles.bottomWrapper}>
        {/* Check  eligibility */}
        <div className="f-between">
          <span className="text-18 accent">Check your eligibility</span>{" "}
          <Switch
            size="small"
            checked={eligibility}
            onChange={handleEligibilityChange}
          />
        </div>
      </div>

      <img
        src={CircleOrange}
        className={clsx(styles.circleDecorator, "no-select")}
      />
    </div>
  );
};

export default TagList;
